/*
 * 戒导航 · 头像审核（jiedh/avatar-guard）前台 JS 总出口
 *
 * 设计依据：doc/内容二次复核队列设计方案.md（v1.1）§4.8「系统消息通知」。
 *
 * 运行范围：论坛前台（SPA）。后台另有独立入口 js/admin.ts，两者互不干扰。
 *
 * ⚠️ 关键：Flarum 的 Application::bootExtensions() 只读取扩展模块的 `extend` 键，
 * 所以这里必须写 `export { default as extend } from './extend';`，而不是默认导出
 * —— 写错了通知组件不会注册，但也不报错（通知面板一片空白），极难排查。
 */
import app from 'flarum/forum/app';

// 扩展声明：注册二次复核记录模型 + 内容违规通知卡片（见 ./extend.ts）
export { default as extend } from './extend';
app.initializers.add('jiedh-avatar-guard', () => {
  // 本模块前台无需额外初始化动作：
  //   - 通知组件通过 Extend.Notification().add() 注册（见 ./extend.ts）；
  //   - 点击通知的跳转（/settings 重新上传头像）、原因展示全部在组件内完成。
});